import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const baseBonuses = [{
  id: '01',
  icon: '🖼️',
  title: 'Biblioteca de Diseños e Imágenes Editables',
  value: '$9.000',
  desc: 'Más de 500 imágenes y diseños editables para tus decoraciones.',
  for: 'Para que no dependas de buscar en Pinterest ni pagar por imágenes sueltas. Tenés un banco propio, organizado por tipo de evento, listo para usar en tus propuestas.'
}, {
  id: '02',
  icon: '💵',
  title: 'Plantillas de Presupuesto',
  value: '$8.000',
  desc: 'Plantilla lista para cobrarle al cliente sin quedar cara ni regalar tu trabajo.',
  for: 'Para que sepas exactamente cuánto cobrar según el tipo de evento, sin improvisar un número al aire.'
}, {
  id: '03',
  icon: '📋',
  title: 'Checklist de Lista de Invitados',
  value: '$6.000',
  desc: 'Planilla para organizar invitados, confirmaciones y mesas.',
  for: 'Para que puedas ofrecerle al cliente algo más que decoración — un servicio de organización completo.'
}, {
  id: '04',
  icon: '🗓️',
  title: 'Cronograma de Montaje',
  value: '$7.000',
  desc: 'Planilla de horarios y tareas para el día del evento.',
  for: 'Para que el día D no sea un caos. Sabés qué armar primero, a qué hora llega cada proveedor, y no te agarra el apuro.'
}];
export function BaseBonuses() {
  const [openId, setOpenId] = useState<string | null>('01');
  return <section className="py-16 px-5 bg-sage text-white" data-id="element-15">
      <div className="max-w-md mx-auto" data-id="element-16">
        <h2 className="text-3xl font-bold text-center mb-2" data-id="element-17">
          4 bonos incluidos. Gratis. Siempre.
        </h2>
        <p className="text-center text-white/90 mb-10 text-[15px]" data-id="element-18">
          Valor total:{' '}
          <span className="line-through opacity-70" data-id="element-19">$36.000 ARS</span> →{' '}
          <span className="font-bold text-white bg-white/20 px-2 py-0.5 rounded" data-id="element-20">
            $0 con tu sistema.
          </span>
        </p>

        <div className="flex flex-col gap-3" data-id="element-21">
          {baseBonuses.map(bono => <div key={bono.id} className="bg-white/10 border border-white/20 rounded-2xl overflow-hidden backdrop-blur-sm" data-id="element-22">
              <button onClick={() => setOpenId(openId === bono.id ? null : bono.id)} className="w-full p-4 flex items-center justify-between text-left active:bg-white/10 transition-colors" data-id="element-23">
                <div className="flex items-center gap-3" data-id="element-24">
                  <span className="text-2xl" data-id="element-25">{bono.icon}</span>
                  <div data-id="element-26">
                    <div className="text-xs font-bold text-white/70 uppercase tracking-wider mb-0.5" data-id="element-27">
                      Bono {bono.id}
                    </div>
                    <div className="font-bold text-[15px] leading-tight" data-id="element-28">
                      {bono.title}
                    </div>
                  </div>
                </div>
                <ChevronDown className={`w-5 h-5 text-white/70 shrink-0 transition-transform duration-300 ${openId === bono.id ? 'rotate-180' : ''}`} data-id="element-29" />
              </button>

              <AnimatePresence initial={false} data-id="element-30">
                {openId === bono.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-31">
                    <div className="p-4 pt-0 border-t border-white/10 mt-2" data-id="element-32">
                      <div className="flex items-center gap-2 mb-3 mt-3" data-id="element-33">
                        <span className="line-through text-white/60 text-sm" data-id="element-34">
                          {bono.value}
                        </span>
                        <span className="bg-white text-sage text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-35">
                          GRATIS
                        </span>
                      </div>
                      <p className="font-medium text-[15px] mb-3" data-id="element-36">
                        {bono.desc}
                      </p>
                      <div className="bg-black/10 p-3 rounded-xl text-sm text-white/90" data-id="element-37">
                        <span className="font-bold" data-id="element-38">Para qué sirve:</span>{' '}
                        {bono.for}
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}